export enum AuthLevel {
  AUTH = 'auth',
  PUBLIC = 'public',
  ADMIN = 'admin',
  JWT_AUTH = 'jwt-auth',
}
